(function () {
    'use strict';

    run.admin.parts.backgroundSelector = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;
        const rackoot_data = document.getElementById('rackoot_data');
        const backgroundCoverEl = document.getElementById('background_cover');
        const rackootInfoPanelEl = document.getElementById('rackoot_info_panel');

        // Background selector
        const bg_button_wrap = document.getElementById('bg_change_open');
        if (bg_button_wrap !== null) {
            const bg_button = bg_button_wrap.getElementsByTagName('span')[0];
            bg_button.addEventListener('click', function(e) {
                let current_style_body = document.body.style.cssText;
                let current_style_button = bg_button.style.cssText;
    
                let html = `
                    <form name="rackoot_backgrounds_grid" id="rackoot_backgrounds_grid">
                        <div id="backgrounds_samples_container">
                            <ul class="nav nav-tabs nav-fill mb-3" id="tabs_bgs" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="bg-tab-solid" data-bs-toggle="tab" href="#backgrounds-solid" role="tab" aria-controls="backgrounds-solid" aria-selected="true">`+translations.rackoots.backgrounds.selector.tabs.solid+`</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="bg-tab-gradients" data-bs-toggle="tab" href="#backgrounds-gradients" role="tab" aria-controls="backgrounds-gradients" aria-selected="false">`+translations.rackoots.backgrounds.selector.tabs.gradients+`</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="bg-tab-image" data-bs-toggle="tab" href="#backgrounds-images" role="tab" aria-controls="backgrounds-images" aria-selected="false">`+translations.rackoots.backgrounds.selector.tabs.images+`</a>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="bg-tab-custom" data-bs-toggle="tab" href="#backgrounds-custom" role="tab" aria-controls="backgrounds-custom" aria-selected="false">`+translations.rackoots.backgrounds.selector.tabs.custom+`</a>
                                </li>
                            </ul>

                            <div class="tab-content" id="bg-tabs-content">
                                <div class="tab-pane fade show active" id="backgrounds-solid" role="tabpanel" aria-labelledby="bg-tab-solid">
                                    <div class="backgrounds_samples">`;
                    
                                        for (const [key, values] of Object.entries(backgrounds['solid'])) {
                                            html += `<div class="bg_sample" data-type="solid" data-value="var(--bg-solid-`+key+`)" style="background: var(--bg-solid-`+key+`)"></div>`;
                                        }
                    html += `
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="backgrounds-gradients" role="tabpanel" aria-labelledby="bg-tab-gradients">
                                    <div class="backgrounds_samples">`;
                                        for (const [key, values] of Object.entries(backgrounds['gradients'])) {
                                            html += `<div class="bg_sample" data-type="gradients" data-value="var(--bg-gradients-`+key+`)" style="background: var(--bg-gradients-`+key+`)"></div>`;
                                        }
                    html += `
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="backgrounds-images" role="tabpanel" aria-labelledby="bg-tab-image">
                                    <div class="backgrounds_samples">`;
                                        for (const [key, values] of Object.entries(backgrounds['images'])) {
                                            html += `<div class="bg_sample" data-type="images" data-value="var(--bg-images-`+key+`)" style="background: var(--bg-images-`+key+`)"></div>`;
                                        }
                    html += `
                                   </div>
                                </div>
                                <div class="tab-pane fade" id="backgrounds-custom" role="tabpanel" aria-labelledby="bg-tab-image">
                                    <div class="backgrounds_samples container">
                                        <label class="form-label">`+translations.rackoots.backgrounds.selector.customInput.label+`</label>
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control" id="custom_background" value="`+rackoot_data.dataset.backgroundCustom+`">
                                                    <button type="button" class="btn btn-outline-primary" id="btn_apply_custom_background"><i class="fa fa-check"></i> Apply</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="mb-3">
                                                    <h5>`+translations.rackoots.backgrounds.selector.cover.label+`</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-4">
                                                <label class="d-block">`+translations.rackoots.backgrounds.selector.cover.labelColor+`</label>
                                                <input type="color" class="form-control form-control-color" id="background_cover_color" name="background_cover_color" value="`+rackoot_data.dataset.backgroundCoverColor+`">
                                            </div>
                                            <div class="col-4">
                                                <label class="d-block">`+translations.rackoots.backgrounds.selector.labelTextColor+`</label>
                                                <input type="color" class="form-control form-control-color" id="text_color" name="text_color" value="`+rackoot_data.dataset.textColor+`">
                                            </div>
                                            <div class="col-4">
                                                <label class="d-block">`+translations.rackoots.backgrounds.selector.cover.labelOpacity+`</label>
                                                <input type="range" id="background_cover_opacity" name="background_cover_opacity" min="0" max="1" step="0.05" value="`+rackoot_data.dataset.backgroundCoverOpacity+`">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>`;
    
                Swal.fire({
                    title: translations.rackoots.backgrounds.selector.title,
                    html: html,
                    showCloseButton: false,
                    showConfirmButton: true,
                    confirmButtonText: translations.confirmAlerts.close,
                    buttonsStyling: false,
                    reverseButtons: true,
                    width: '40%',
                    customClass: {
                        cancelButton: 'btn btn-lg btn-secondary',
                        confirmButton: 'btn btn-lg btn-primary ms-4'
                    },
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    },
                    didOpen: () => {
                        const textColorEl = document.getElementById('text_color');
                        const coverColorEl = document.getElementById('background_cover_color');
                        const coverOpacityEl = document.getElementById('background_cover_opacity');
                        textColorEl.addEventListener('input', function(e) {
                            applyCoverStyle();
                            saveCoverStyle();
                        })
                        coverColorEl.addEventListener('input', function(e) {
                            applyCoverStyle();
                            saveCoverStyle();
                        })
                        coverOpacityEl.addEventListener('change', function(e) {
                            applyCoverStyle();
                            saveCoverStyle();
                        })
                        coverOpacityEl.addEventListener('input', function(e) {
                            applyCoverStyle();
                        })

                        function applyCoverStyle()
                        {
                            rackootInfoPanelEl.style.setProperty('--color', textColorEl.value);
                            backgroundCoverEl.style.backgroundColor = coverColorEl.value;
                            backgroundCoverEl.style.opacity = coverOpacityEl.value;
                            rackoot_data.dataset.backgroundCoverColor =  coverColorEl.value;
                            rackoot_data.dataset.textColor = textColorEl.value;
                            rackoot_data.dataset.backgroundCoverOpacity = coverOpacityEl.value;
                        }

                        document.addEventListener('click',function(e) {
                            let clicked_save_button = e.target.closest('#btn_apply_custom_background');
                            if (clicked_save_button) {
                                const customBackgroundUrlInput = document.getElementById('custom_background')
                                const customBackgroundUrl = customBackgroundUrlInput.value.trim();
                                if (customBackgroundUrl !== null && customBackgroundUrl !== '')  {
                                    applyCoverStyle();
                                    setBackground('custom', customBackgroundUrl);
                                } else {
                                    setBackground('images', 'var(--bg-images-sf_1000000)');
                                }
                            }
                        });
            
                        function saveCoverStyle()
                        {
                            var data = new FormData();
                            data.append('csrf_name', csrf_name);
                            data.append('csrf_value', csrf_value);
                            data.append('rackoot_uuid', rackoot_data.dataset.uuid);
                            data.append('text_color', textColorEl.value);
                            data.append('background_cover_color', coverColorEl.value);
                            data.append('background_cover_opacity', coverOpacityEl.value);
            
                            axios.post(GlobalRoutes.rackoots.save_background_cover, data)
                        }
                    }
                }).then((result) => {
                    if (result.value) {
                    } else {
                        // restore original
                        // document.body.style = current_style_body;
                        // bg_button.style = current_style_button;
                    }
                });
            });

            function removeCoverStyle()
            {
                rackootInfoPanelEl.style.removeProperty('--color');
                backgroundCoverEl.style.removeProperty('background-color');
                backgroundCoverEl.style.removeProperty('opacity');
            }

            document.addEventListener('click',function(e) {
                if (e.target && e.target.classList.contains('bg_sample')) {
                    removeCoverStyle();
                    setBackground(e.target.dataset.type, e.target.dataset.value);
                }
            });

            function setBackground(type, background)
            {
                const button_el = document.getElementById('bg_change_open').getElementsByTagName('span')[0];
                const body_el = document.getElementsByTagName('body')[0];
                const custom_background_el = document.getElementById('custom_background');
                const background_cover  = document.getElementById('background_cover');
                let styles;
                switch (type) {
                    case 'images':
                        styles = {
                            backgroundImage: background,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center center',
                        }
                        Object.assign(button_el.style, styles)
                        Object.assign(body_el.style, styles)
                        background_cover.classList.add('show');
                        removeCoverStyle();
                        break;
                    case 'custom':
                        styles = {
                            backgroundImage: "url('"+background+"')",
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center center',
                        }
                        Object.assign(button_el.style, styles)
                        Object.assign(body_el.style, styles)
                        rackoot_data.dataset.backgroundCustom = background
                        background_cover.classList.add('show');
                        break;
                    default:
                        button_el.style.background = background;
                        body_el.style.background = background;
                        background_cover.classList.remove('show');
                        removeCoverStyle();
                        break;
                }

                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('rackoot_uuid', rackoot_data.dataset.uuid);
                data.append('background', background);
                data.append('background_type', type);

                axios.post(GlobalRoutes.rackoots.set_background, data)
            }
        }
    }
})();